import React, { useState } from 'react';
import NxtbnModal from '../../components/Modal';
import { NXForm, InputField } from "../../components/common"
import SelectStyled from '../../components/Select';
import { useSelector } from 'react-redux';
import { RootState } from "../../redux/rootReducer";
import { useQuery, gql, useMutation } from '@apollo/client';

interface ExchangeRateFormProps {
  isOpen: boolean;
  onClose: () => void;
  refresh: () => void;
}

const GET_ALLOWED_CURRENCIES = gql`
  query MyQuery {
    allowedCurrencyList {
      value
      label
    }
  }
`;



const CREATE_EXCHANGE_RATE = gql`
  mutation MyMutation($input: CurrencyExchangeInput!) {
    createExchangeRate(input: $input) {
      currencyExchange {
        id
        exchangeRate
        lastModified
        targetCurrency
        baseCurrency
      }
    }
  }
`;


const ExchangeRateForm: React.FC<ExchangeRateFormProps> = ({ isOpen, onClose, refresh }) => {
  const [formData, setFormData] = useState<any>({});
  const me = useSelector((state: RootState) => state.auth.me);

  const [createExchangeRate, { loading: mutationLoading, error: mutationError }] = useMutation(CREATE_EXCHANGE_RATE);

  const { data, loading, error } = useQuery(GET_ALLOWED_CURRENCIES);


  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData((prev: any) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSelectChange = (e: any, name: string) => {
    setFormData((prev: any) => ({ ...prev, [name]: e.value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Call the mutation
    try {
      await createExchangeRate({
        variables: {
          input: {
            baseCurrency: me?.baseCurrency || '',
            targetCurrency: formData.targetCurrency,
            exchangeRate: parseFloat(formData.exchangeRate),
          },
        },
      });
      refresh();
      onClose();
    } catch (err) {
      console.error("Error creating exchange rate:", err);
    }
  };

  return (
    <NxtbnModal isOpen={isOpen} onClose={onClose}>
      <NXForm className="p-6 space-y-4" onSubmit={handleSubmit} title="Add Exchange Rate">
        <div className="grid grid-cols-1 gap-y-4 sm:grid-cols-2 sm:gap-x-6">
          <div>
            <label htmlFor="baseCurrency" className="block text-sm font-medium text-gray-700">
              Base Currency
            </label>
            <SelectStyled
              name="baseCurrency"
              defaultValue={{ value: me?.baseCurrency, label: me?.baseCurrency }}
              isDisabled
            />
          </div>
          <div>
            <label htmlFor="targetCurrency" className="block text-sm font-medium text-gray-700">
              Target Currency
            </label>
            <SelectStyled
              name="targetCurrency"
              options={data?.allowedCurrencyList || []}
              onChange={(e: any) => handleSelectChange(e, 'targetCurrency')}
              required
            />
          </div>
          <div>
            <label htmlFor="exchangeRate" className="block text-sm font-medium text-gray-700">
              Exchange Rate
            </label>
            <InputField
              type="number"
              id="exchangeRate"
              name="exchangeRate"
              value={formData?.exchangeRate || ''}
              onChange={handleChange}
              required
              step="0.01"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            />
          </div>
        </div>
        <div className="mt-6 flex justify-end">
          <button
            type="button"
            onClick={onClose}
            className="mr-3 inline-flex justify-center rounded-md border border-transparent px-4 py-2 bg-gray-600 text-base font-medium text-white shadow-sm hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="inline-flex justify-center rounded-md border border-transparent px-4 py-2 bg-primary-600 text-base font-medium text-white shadow-sm hover:bg-primary-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
          >
            Submit
          </button>
        </div>
      </NXForm>
    </NxtbnModal>
  );
};

export default ExchangeRateForm;
